export const environment = {
  production: false,
  apiUrl: 'https://api.cup.coll.blank-software.it/v1',
};
